import { FC, useState } from "react";
import InfoCard from "./InfoCard";
import InfoText from "./InfoText";
import { EquipmentType, MenuType } from "../../app/types/ProposalTypes";

interface TabsProps {
  menus: MenuType[];
  locale: string;
  equipments: EquipmentType[];
  terms: string;
}

const Tabs: FC<TabsProps> = ({ menus, equipments, locale, terms }) => {
  const [activeTab, setActiveTab] = useState<Number>(
    menus.length > 0 ? 0 : equipments.length > 0 ? 1 : 2,
  );

  if (menus.length === 0 && equipments.length === 0 && terms.length === 0) {
    return null;
  }

  const renderContent = () => {
    switch (activeTab) {
      case 0:
        if (menus.length === 0) {
          return null;
        }

        return menus.map((menu, index) => {
          return (
            <InfoCard
              title={menu.name[locale]}
              description={menu.description[locale]}
              price_text={menu.price}
              img_url={menu.img_url}
              key={`menus_${index}`}
            />
          );
        });
      case 1:
        if (equipments.length === 0) {
          return null;
        }

        return equipments.map((equipment) => {
          return (
            <InfoCard
              title={equipment.name[locale]}
              description={equipment.description[locale]}
              price_text={equipment.price}
              img_url={equipment.images[0]?.url || null}
              key={`equipments_${equipment.id_equipment}`}
            />
          );
        });

      case 2:
        return <InfoText terms={terms} />;
    }
  };

  const renderTab = (text: string, no: number) => {
    if (activeTab === no) {
      return (
        <div className="px-4 pt-4 bg-white rounded-t-lg  text-[#2D2020]  font-normal text-base cursor-pointer">
          <div className="border-b-4 border-b-[#D99B85] h-full">{text}</div>
        </div>
      );
    }

    return (
      <div
        onClick={() => setActiveTab(no)}
        className="p-4 bg-[#F3F3F0] text-[#495366]  font-normal text-base rounded-t-lg cursor-pointer"
      >
        {text}
      </div>
    );
  };

  return (
    <div className="w-full">
      <div className="flex flex-row m-0 gap-1 lg:px-0 xs:px-1">
        {menus.length > 0 &&
          renderTab(
            globalThis.translate.em.proposal.signature_page.tabs.selected_menu,
            0,
          )}
        {equipments.length > 0 &&
          renderTab(
            globalThis.translate.em.proposal.signature_page.tabs.upgrade,
            1,
          )}
        {terms.length > 0 &&
          renderTab(
            globalThis.translate.em.proposal.signature_page.tabs.conditions,
            2,
          )}
      </div>
      <div className="bg-white p-6 rounded-tl-none  rounded-2xl gap-6 flex flex-col">
        {renderContent()}
      </div>
    </div>
  );
};

export default Tabs;
